"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.OxidizingAgentLinear = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

var _SvgIcon = require("../SvgIcon");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var OxidizingAgentLinear = function OxidizingAgentLinear(props) {
  return /*#__PURE__*/React.createElement(_SvgIcon.SvgIcon, (0, _extends2.default)({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M9.867.257c0-.096-.066-.184-.17-.228a.364.364 0 00-.322.02C8 .858 6.854 2.223 6.454 3.526c-.278.907-.315 1.127-.32 1.8-1.269-.223-1.556-.987-1.56-1.004a.265.265 0 00-.161-.19.37.37 0 00-.282-.004c-.067.026-1.633.682-1.724 3.301a3.585 3.585 0 00-.007.262c0 .836.327 1.62.8 2.297h.017a4.8 4.8 0 019.566 0h.017c.473-.677.8-1.461.8-2.297a9.04 9.04 0 00-.032-.486c-.17-1.835-1.207-2.985-2.122-4v-.001c-.848-.94-1.58-1.751-1.58-2.948z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 14.4a4 4 0 100-8 4 4 0 000 8zm0-1.6A2.4 2.4 0 108 8a2.4 2.4 0 000 4.8z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 14.4H4A.8.8 0 004 16h8a.8.8 0 100-1.6H8z",
    fill: "currentColor"
  }));
};

exports.OxidizingAgentLinear = OxidizingAgentLinear;
var _default = OxidizingAgentLinear;
exports.default = _default;